<template>
  <div class="beta">
    <div class="container">
      <div class="inner">
        <div style="text-align:center;">
          <img src="@/assets/logo.svg" width="200" />
        </div>
        <h1>ベータテスター様専用ユーザー登録ページ</h1>

        <div class="guide-container">
          <p class="guide">
            この度は合同会社プロンエイドのプロダクト「3D透視発音
            ～ネイティブの口～」のベータテストにご参加いただき有難うございます。
          </p>
          <p class="guide">
            現在、本サービスはテスト中のため、バグを発見された場合、またはご意見がある際は、サインイン後上部ナビゲーションにございます
            <button
              class="button mock"
            >フィードバック</button>からフィードバックを送って頂けますと幸いです。
          </p>

          <p class="nda"></p>

          <p class="guide">登録が完了すると自動的にサインインし、アプリケーションサイトに移動します。</p>

          <p>
            本サービスはPCまたはMacのGoogle
            Chromeでのみ動作します。インストールされていない場合は、お手数ですが
            <a
              href="https://www.google.com/intl/ja_jp/chrome/"
              target="”_blank”"
            >こちら</a>からインストールしてください。
          </p>
        </div>

        <el-dialog title="秘密保持の誓約" :visible.sync="dialogFormVisible">
          <div class="secret">
            <p>
              合同会社プロンエイドが制作した3D透視発音 ～ネイティブの口～
              を使用するにあたり、下記事項を遵守することを誓約します。
            </p>
            <ol>
              <li>使用する過程で知り得る一切の情報を、自己の利益のための者若しくは当社と競合する他の事業者その他当社に対して不利益を被る可能性のある第三者にも機密情報を漏洩または開示をしない。</li>
              <li>許可なく情報を紙、FD、CDなどの記録媒体に記録し、又は電子媒体（メールアカウントへのメール発信や転送等を含む）等を用いて外部へ持ち出さないこと。</li>
              <li>万一、上記事項に違反したことにより、当社に損害を与えた場合には、その責めに応じかつ賠償を請求されたとしても異議の申立をせず、その請求に応じるものとする。</li>
            </ol>

            <p style="text-align: right">以 上</p>
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="agree()">同意する</el-button>
          </span>
        </el-dialog>

        <el-form label-width="150px">
          <el-form-item label="お名前" prop="name">
            <el-input v-model="name"></el-input>
          </el-form-item>
          <el-form-item label="メールアドレス" prop="name">
            <el-input v-model="email"></el-input>
          </el-form-item>

          <el-form-item label="パスワード" prop="name">
            <el-input type="password" v-model="password"></el-input>
          </el-form-item>
          <!-- <el-form-item label="～への同意">
            <el-checkbox label="同意する" name="type"></el-checkbox>
          </el-form-item>-->

          <div class="button-container">
            <button
              @click.prevent="dialogFormVisible = true"
              class="button register"
              style="margin-right: 20px"
            >秘密保持の誓約書類を確認</button>
            <button
              @click.prevent="register"
              class="button register"
              :class="[
                { 'loading disabled': loading },
                { 'white disabled': !agreed }
              ]"
            >{{ loading ? "登録中" : "登録" }}</button>
          </div>
        </el-form>

        <!-- <el-alert
          title="メールを送信しました"
          type="success"
          description="ご入力頂いたメールアドレスに確認用のメールを送信しました。メールに記載されているURLをクリックして本登録を完了してください。"
          show-icon
        ></el-alert>-->

        <el-alert
          :title="`エラーが発生しました (error code: ${errCode})`"
          type="error"
          :description="errDescription"
          show-icon
          v-show="err"
        ></el-alert>
        <button class="button white" @click="goToSignInPage" style="margin-top: 20px">サインインページへ</button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "Beta",
  data() {
    return {
      loading: false,
      err: false,
      errCode: "",
      errDescription: "",
      email: "",
      password: "",
      name: "",
      dialogFormVisible: false,
      agreed: false
    };
  },
  created() {
    document.title = "ネイティブの口 | ベータユーザー登録ページ";
  },
  methods: {
    agree() {
      this.dialogFormVisible = false;
      this.agreed = true;
    },
    goToSignInPage() {
      this.$router.push("/");
    },
    register() {
      let self = this;

      console.log(this.agreed);
      if (this.agreed) {
        this.loading = true;
        firebase.auth().useDeviceLanguage();
        firebase
          .auth()
          .createUserWithEmailAndPassword(self.email, self.password)
          .then(user => {
            self.err = false;
            const currentUser = firebase.auth().currentUser;
            currentUser
              .updateProfile({
                displayName: self.name
              })
              .then(function() {
                self.$store.commit("auth/setName", self.name);
                self.$router.replace("/dashboard");
              })
              .catch(function(error) {
                // An error happened.
                console.log(err);
                self.$router.replace("/dashboard");
                self.loading = false;
              });
          })
          .catch(err => {
            self.errCode = err.code;
            self.errDescription = err.message;
            self.loading = false;
            self.err = true;
          });
      } else {
        self.errCode = "no-agree-error";
        self.errDescription = "秘密保持の誓約に同意する必要があります";
        self.err = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
}
h1 {
  text-align: center;
  margin: 35px 0;
}
.inner {
  max-width: 80%;
  margin: 0 auto;
  position: relative;
}

.button-container {
  text-align: center;
}

.register {
  margin: 20px 0;
  vertical-align: middle;
  padding: 5px 30px;
  font-size: 0.9rem;
  border-radius: 20px;
  transition: padding 0.5s ease, opacity 0.5s ease, width 0.5s ease;
  img {
    width: 20px;
    vertical-align: middle;
  }
}

.loading {
  background-image: url("../../assets/spinner.svg");
  background-repeat: no-repeat;
  background-position-y: center;
  background-position-x: 90%;
  background-size: 22px;
  padding: 5px 43px 5px 25px;
}
.guide-container {
  margin: 30px;
  font-weight: bold;
}

.mock {
  margin: 0 7px 0 3px;
  transform: scale(0.9);
  cursor: default;
}

.secret {
  font-size: 1rem;
}
</style>
